import React, { PropsWithChildren } from "react";
import { Box, Typography } from "@mui/material";

type AdminHeadingProps = PropsWithChildren<{ component?: React.ElementType }>;

/** Page heading for admin dashboard pages (replaces the legacy `.heading` css class). */
export const AdminHeading: React.FC<AdminHeadingProps> = ({ children, component = "h3" }) => (
  <Typography variant="h5" component={component} sx={{ mb: 2.5 }}>
    {children}
  </Typography>
);

/** Constrains admin create/update forms to a readable width (replaces the legacy `.formWidth`). */
export const AdminFormLayout: React.FC<PropsWithChildren> = ({ children }) => (
  <Box sx={{ maxWidth: 800 }}>{children}</Box>
);
